module.exports = __webpack_public_path__ + "static/media/community-service-banner.036c621f.jpg";